/**
 * Returns true when a pointer event target lives in portaled UI that sits
 * outside the drawer DOM but is still part of the current interaction
 * (Radix popovers/selects, sonner toasts, etc.).
 */
export function isDrawerOutsideInteractionTarget(
    target: EventTarget | null,
): boolean {
    if (!(target instanceof Element)) {
        return false;
    }

    return Boolean(
        target.closest(
            [
                '[data-sonner-toaster]',
                '[data-slot="popover-content"]',
                '[data-slot="select-content"]',
            ].join(', '),
        ),
    );
}
